module.exports = __webpack_public_path__ + "img/theCover_03.b2dc85a5.jpg";